import {
	CreateVehicleDto,
	UpdateVehicleDto,
} from 'models/vehicles/interfaces/vehicles.interface';
import * as yup from 'yup';

const vehicleValidations = {
	internalId: yup
		.string()
		.matches(/^[a-zA-Z0-9]+$/)
		.required('Campo requerido'),
	description: yup.string().nullable(),
};

export const vehicleValidationSchema = yup.object(vehicleValidations);

export const vehicleDefaults: UpdateVehicleDto | CreateVehicleDto = {
	internalId: undefined,
	description: undefined,
};
